import IconBase, { type IconProps } from './icons/IconBase';

export default function TumblrIcon(props: IconProps) {
  return (
    <IconBase color="#36465D" {...props}>
      <path d="M39.2,41c-0.6,0.3-1.6,0.5-2.4,0.5c-2.4,0.1-2.9-1.7-2.9-3v-9.3h6v-4.5h-6V17c0,0-4.3,0-4.4,0 c-0.1,0-0.2,0.1-0.2,0.2c-0.3,2.3-1.4,6.4-5.9,8.1v3.9h3V39c0,3.4,2.5,8.1,9,8c2.2,0,4.7-1,5.2-1.8L39.2,41z" />
    </IconBase>
  );
}
